<template>
    <div class="Kontrow-Principal">
        <PageTitle icon="fa fa-phone" main="Telemetria"
            sub="Monitoramento" />
        <div class="Kontrow-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Monitoramento" active><KontrowMonitoramento /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores"><KontrowPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import KontrowMonitoramento from '../kontrow/KontrowMonitoramento'
import KontrowPainel from '../kontrow/KontrowPainel'
export default {
    name: 'KontrowPrincipal',    
    components: { PageTitle, KontrowMonitoramento,KontrowPainel}
    
}
</script>

<style>

</style>






